import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Environment } from '@environments/interface.environment';
import { UserService } from '@app/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private http: HttpClient, @Inject(CUSTOMERENVIRONMENT) private environment: Environment, private userService: UserService) { }

  private isUserMemberOfGroup$ = new Map<string, Observable<boolean>>();

  hasUserPdpRole(role: number): Observable<boolean> {
    return this.userService.getOrCreateMe().pipe(
      map(user => {
        return user.Role === role;
    })
  ); }
}
